/**************************************************
 * Nombre:       Tarjeta_Premio_Ver
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Cange_Puntos from "../Dialogos/Dialogo_Cange_Puntos";
import {obtenerTotalPuntos} from "../../CodigoCliente/Puntos/obtenerTotalPuntos";
import {obtenerPremio} from "../../CodigoCliente/Puntos/obtenerPremio";
import {todos} from "../../Constantes";
import {theme} from "../../Tema";
import {PublishedWithChangesOutlined} from '@mui/icons-material'
import Dialogo_Ver_Premio from "../Dialogos/Dialogo_Ver_Premio";

const Tarjeta_Premio_Ver = ({item}) => {
    const cData = useContext(usuarioContext)
    const {sCell} = useResponsive()
    const [totalPuntos, setTotalPuntos] = useState(0);
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Cange_Puntos, titulo: 'Cange de puntos'})
    const {Dialogo: DialogoDetalles, abrir: abrirDetalles} = useDialogo({
        Componente: Dialogo_Ver_Premio,
        titulo: `Detalle de ${item.nombre}`,
    })
    const [premio, setPremio] = useState(false)

    useEffect(() => {

        obtenerTotalPuntos(cData.usuario.id).then((dox) => {
            setTotalPuntos(dox);
            setPremio(obtenerPremio({items: todos, puntos: dox}))
        })


    }, []);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 1,
                p: 2,
                color: '#011237',
                minHeight: 170
            }}
        >

            <Dialogo/>

            <DialogoDetalles/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{
                            fontSize: 16,
                            fontWeight: 400
                        }}>{`Canjealo por: ${item.valor} puntos`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{
                            fontSize: 24,
                            fontWeight: 600,
                            color: theme.palette.primary.main,
                            lineHeight: 1.2,
                            height: 41
                        }}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}}
                          sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Button
                            onClick={() => abrir(item)}
                            fullWidth
                            disabled={item.valor >= totalPuntos}
                            startIcon={<PublishedWithChangesOutlined/>}
                            sx={{backgroundColor: '#011237'}}
                        >Canjear</Button>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 4}}>
                        <Button
                            onClick={() => abrirDetalles(item)}
                            variant={'outlined'}>Detalles</Button>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 5, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                <img src={''} width={'100%'} height={'auto'}
                     style={{borderRadius: 10, filter: premio ? '' : 'grayscale(100%)'}}/>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Premio_Ver